import { render } from "./ControlTheSizeOfTheSpace.vue?vue&type=template&id=06ddfcad"
import script from "./ControlTheSizeOfTheSpace.vue?vue&type=script&lang=js"
export * from "./ControlTheSizeOfTheSpace.vue?vue&type=script&lang=js"

import "./ControlTheSizeOfTheSpace.vue?vue&type=style&index=0&id=06ddfcad&lang=scss"
script.render = render

export default script